import o from "./index.es334.js";
import * as m from "./index.es335.js";
const t = {
  ...m,
  ...o
};
export {
  t as default
};
//# sourceMappingURL=index.es242.js.map
